define(
    'viewmodels/login',[
        "viewmodels/ViewModel",
        "plugins/router",
        "services/config",
        "providers/dataprovider",
        "i19n!i19n/strings"
    ],
    function (ViewModel, router, config, dataProvider, i19n) {

        var vm = new ViewModel(
            {
                i19n: i19n,
                version: ko.observable(''),
                login: {
                    email: ko.observable().extend({ email: true, required: true }),
                    password: ko.observable().extend({ required: true }),
                    visible: ko.observable(true),
                    show: function () {
                        if (!vm.reset.submit.isExecuting()) {
                            vm.reset.visible(false);
                            vm.reset.successVisible(false);
                            vm.login.visible(true);
                        }
                    }
                },

                reset: {
                    email: ko.observable().extend({ required: true, email: true }),
                    visible: ko.observable(false),
                    successVisible: ko.observable(false),
                    show: function () {
                        if (!vm.login.submit.isExecuting()) {
                            vm.reset.visible(true);
                            vm.reset.successVisible(false);
                            vm.login.visible(false);
                        }
                    }
                }
            });

        vm.activate = function () {
            var device = getMobileOperatingSystem();
            if (device && device != 'ipad') {
                var instanceCode = config.instanceCode ? config.instanceCode : window.location.hostname.split('.')[0];
                var baseUrl = window.location.hostname.replace(instanceCode + ".", "");

                window.location.href = window.location.protocol + "//mobile." + baseUrl + "/" + instanceCode + "/#login";

                return false;
            }

            vm.reset.visible(false);
            vm.reset.successVisible(false);
            vm.login.visible(true);
        };
        vm.attached = function () {
            ////vm.version(String.format(i19n.to.todownloadthefileplanclientforwindows78learnmore, requirejs.s.contexts._.config.urlArgs.replace("version=", "")));
            //vm.version(requirejs.s.contexts._.config.urlArgs.replace("version=", ""));
            vm.version(window.fileplan.version.replace("version=", ""));
            vm.reset.email.extend({ validation: { async: true, validator: mustValidEmail, message: i19n.to.invalidemailaddresspleasemakesure } });

            //var device = getMobileOperatingSystem();
            //if (device && device != 'ipad') {
            //    var instanceCode = config.instanceCode ? config.instanceCode : window.location.hostname.split('.')[0];
            //    var baseUrl = window.location.hostname.replace(instanceCode + ".", "");

            //    window.location.href = window.location.protocol + "//mobile." + baseUrl + "/" + instanceCode + "/#login";

            //    return;
            //}
        };

        vm.login.serverErrors = ko.observableArray();
        vm.login.errors = ko.validation.group(vm.login);
        vm.login.isValid = ko.computed(function () {
            return vm.login.errors().length == 0;
        });

        vm.login.submit = ko.asyncCommand({
            execute: function (complete) {
                vm.login.serverErrors([]);

                if (vm.login.isValid()) {
                    vm.session
                    .login(vm.login.email(), vm.login.password(), vm.rememberMe())
                    .done(function () {
                        sessionStorage.removeItem("status:instancecode");

                        var r = sessionStorage.navto ? sessionStorage.navto : "explorer";

                        if (r) {
                            sessionStorage.removeItem("navto");
                        }

                        router.navigate("#" + r);
                        setTimeout(function () {
                            $('#username').val('');
                            $('#password').val('');

                            vm.login.visible(false);
                        }, 10);

                        // hard-reset 
                        //window.location.assign("#" + r);
                        //window.location.reload(true);

                        complete();

                        sessionStorage.setItem("__hasLogin", "1");
                        //var isInstanceAdmin = vm.session.role == 4;
                        //var isShowSetup = (vm.login.email().indexOf('@radix.com.au') != -1) || (vm.login.email().indexOf('rollie') != -1);

                        //if (!vm.session.settingsGuided().IsDontShowMeAgainNextLogin() && isInstanceAdmin && isShowSetup) {
                        //    dialogService.showDialog("modals/secured/help/SetupGuideModal")
                        //    .then(function (dialogResult) { });
                        //}
                    })
                    .fail(function (e) {
                        complete();

                        e.stopPropagation = true;                                                

                        vm.login.serverErrors(e.error);                        
                    });
                } else {
                    complete();

                    vm.login.errors.showAllMessages();
                }
            }
        });

        // WORKAROUND: ko.validation was adding the rememberMe observable as a validatable due to the ko.validation.group(vm.login) call. 
        // This causes the css not to work because the element is decorated with the validationElement class.
        vm.rememberMe = ko.observable(false);
      
        vm.reset.errors = ko.validation.group(vm.reset);
        vm.reset.isValid = ko.computed(function () {
            return vm.reset.errors().length == 0;
        });
        vm.reset.submit = ko.asyncCommand({
            execute: function (complete) {
                if (vm.reset.isValid()) {
                    var url = window.location.href.toString();
                    url = url.replace('#login', '#reset/id=');

                    dataProvider.accounts
                    .sendResetPasswordLink(vm.reset.email(), url)
                    .done(function () {
                        vm.reset.visible(false);
                        vm.reset.successVisible(true);
                        vm.reset.email('');

                        complete();
                    })
                    .fail(function (e) {
                        e.stopPropagation = true;
                        vm.login.serverErrors(e.error);
                        vm.reset.errors.showAllMessages();
                        
                        complete();
                    });

                } else {
                    vm.reset.errors.showAllMessages();
                    complete();
                }
            },
        });

        return vm;

        function mustValidEmail(d, p, cb) {
            setTimeout(function () {
                cb(true);
            }, 2000);
        }

        function getMobileOperatingSystem() {
            var userAgent = navigator.userAgent || navigator.vendor || window.opera;

            // Windows Phone must come first because its UA also contains "Android"
            if (/windows phone/i.test(userAgent)) {
                return "windows";
            }

            if (/android/i.test(userAgent)) {
                return "google";
            }

            if (/iPad/.test(userAgent) && !window.MSStream) {
                return "ipad";
            }

            if (/iPhone/.test(userAgent) && !window.MSStream) {
                return "iphone";
            }

            if (/iPod/.test(userAgent) && !window.MSStream) {
                return "ipod";
            }

            return "";
        }
    }
);
